import React from "react";
import NavLink from "components/common/navigation/NavLink";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { Link } from "react-router-dom";

const renderNavLink = (to, className, isActive, { children }) => (
  <li className={`${isActive ? `${className}--active` : className}`}>
    <Link className={`${isActive ? `${className}--active` : className}`} to={to}>
      {children}
    </Link>
  </li>
);

const LifestyleAgeingNav = () => (
  <nav className="cxa-page-nav">
    <ul>
      <NavLink
        className="cxa-page-nav__item"
        to="/wellness/lifestyleAgeing/ageYourself"
        renderItem={renderNavLink}
      >
        <FormattedMessage {...messages.ageYourselfDescription} />
      </NavLink>
      <NavLink
        className="cxa-page-nav__item"
        to="/wellness/lifestyleAgeing/questionnaire"
        renderItem={renderNavLink}
      >
        <FormattedMessage {...messages.answerQDescription} />
      </NavLink>
      <NavLink
        className="cxa-page-nav__item"
        to="/wellness/lifestyleAgeing/results"
        renderItem={renderNavLink}
      >
        <FormattedMessage {...messages.yourResultsDescription} />
      </NavLink>
    </ul>
  </nav>
);

export default LifestyleAgeingNav;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/LifestyleAgeingNav.js